import React, { useState, useEffect, useMemo } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const ModifySupplierWithItem = () => {
   useAuthRedirect();
  const { sCode, itemCode, sName } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [code, setCode] = useState(""); 
  const [subDetails, setSubDetails] = useState({});
  const [formData, setFormData] = useState({
    price: "",
    disc: "",
    pf: "",
    gst: ""
  });
  const navigate = useNavigate();

  /////////////////////////////////////////////////////////////
            const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
              const permsLoaded = !!rawPerms;
              
              //✅ Permission checks (safe even if perms not yet loaded; will be false)
              const canEdit = hasPermission("Supplier with SubAssembly", "edit");
              /////////////////////////////////////////////////////////////
    

  const ratingLabels = ["0", "1", "2", "3"];

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/supplierMaster_fetchModify?sCode=${sCode}&branch=${branch}&itemCode=${itemCode}`);
        const items = response.data.modifyItemList;
  
        if (items.length > 0) {
          const item = items[0];
          const ratings = item.SupplierWIDetail_promote ? item.SupplierWIDetail_promote.split(',').map(Number) : [0, 0, 0];
  
          const storeReqHeader1 = {
            itemName: item.itemmaster_name || "N/A",
            uom: item.itemMaster_purchaseUom || "N/A",
            price: item.supplierWIdetail_price || "0",
            gst: item.SupplierWIDetail_CSTtax || "0",
            pf: item.supplierWIdetail_PfPercentage || "0",
            disc: item.supplierWIdetail_discountPercentage || "0",
            quality: ratingLabels[ratings[0]] || "N/A",
            afterSalesSupport: ratingLabels[ratings[1]] || "N/A",
            delivery: ratingLabels[ratings[2]] || "N/A"
          };
  
          setSubDetails(storeReqHeader1);
          setFormData({
            price: storeReqHeader1.price,
            gst: storeReqHeader1.gst,
            pf: storeReqHeader1.pf,
            disc: storeReqHeader1.disc,
            quality: storeReqHeader1.quality,
            afterSalesSupport: storeReqHeader1.afterSalesSupport,
            delivery: storeReqHeader1.delivery
          });
        }
      } catch (error) {
        console.error("Error fetching supplier details:", error);
      }
    };
  
    fetchSupplierDetails();
  }, [sCode, branch, itemCode]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
  
  const price = parseFloat(formData.price) || 0;
  const discount = parseFloat(formData.disc) || 0;
  const pf = parseFloat(formData.pf) || 0;
  const gst = parseFloat(formData.gst) || 0;

  const discountValue = price * (discount / 100);
  const pfValue = price * (pf / 100);
  const taxValue = price * (gst / 100);
  const totalValue = price + taxValue + pfValue - discountValue;

  const promoteTotal = 
  (parseInt(formData.quality, 10) || 0) + 
  (parseInt(formData.afterSalesSupport, 10) || 0) + 
  (parseInt(formData.delivery, 10) || 0);

const handleSubmit = async (e) => {
  e.preventDefault();

 
 
  // ==== Price ====
  if (!formData.price || formData.price.toString().trim() === "") {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Price is required!",
    });
    return;
  }
  const priceVal = Number(formData.price);
  if (isNaN(priceVal) || priceVal <= 0) {
    Swal.fire({
      icon: "error",
      title: "Invalid Price",
      text: "Price must be a positive number.",
    });
    return;
  }

  // ==== Promotion (all 3 required) ====
  if (!formData.quality || !formData.afterSalesSupport || !formData.delivery) {
    Swal.fire({
      icon: "warning",
      title: "Empty Field",
      text: "Please enter all Promotion details (Quality, After Sales Support, Delivery).",
    });
    return;
  }

  // ==== GST ====
if (gst === undefined || gst === null || gst.toString().trim() === "") {
  Swal.fire({
    icon: "warning",
    title: "Empty Field",
    text: "Enter GST Percentage!",
  });
  return;
}
const gstVal = Number(gst);
if (isNaN(gstVal) || gstVal < 0 || gstVal > 100) {
  Swal.fire({
    icon: "error",
    title: "Invalid GST",
    text: "GST must be a number between 0 and 100.",
  });
  return;
}


  // ==== PF ====
if (pf === undefined || pf === null || pf.toString().trim() === "") {
  Swal.fire({
    icon: "warning",
    title: "Empty Field",
    text: "Enter PF Percentage!",
  });
  return;
}
const pfVal = Number(pf);
if (isNaN(pfVal) || pfVal < 0 || pfVal > 100) {
  Swal.fire({
    icon: "error",
    title: "Invalid PF",
    text: "PF must be a number between 0 and 100.",
  });
  return;
}

// ==== Discount ====
if (!formData.disc || formData.disc.toString().trim() === "") {
  Swal.fire({
    icon: "warning",
    title: "Empty Field",
    text: "Enter Discount Percentage!",
  });
  return;
}
const discVal = Number(formData.disc);
if (isNaN(discVal) || discVal < 0 || discVal > 100) {
  Swal.fire({
    icon: "error",
    title: "Invalid Discount",
    text: "Discount must be a number between 0 and 100.",
  });
  return;
}


  
  // === Final Payload ===
  const payload = {
    branch,
    user,
    sCode,
    sName,
    itemCode,
    price: formData.price,
    promotion: `${formData.quality},${formData.afterSalesSupport},${formData.delivery}`,
    prTot: promoteTotal,
    gst,
    pf,
    disc: formData.disc,
    value: isNaN(totalValue) ? 0 : Number(totalValue.toFixed(2)),
  };

  console.log("Payload ready:", payload);

  // === API Call ===
  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put(
      "https://rfs2.infraconsoft.net.in/api/supplierWithItem_modify",
      payload
    );
    Swal.fire("Success", response.data.message, "success");
    navigate(`/inventory/supplierWithItemVIew/${sCode}/${sName}`);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      Swal.fire("Error", error.response.data.message, "error");
    } else {
      Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
  }
};



if (!canEdit) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          
          <div className="back-div">
                              <h2 className="add-txt">Supplier With Item - Modify</h2>
                              <p className="back-button"  onClick={() => navigate(-1)} style={{cursor: 'pointer'}}><i className="fa-solid fa-backward"></i>  Back</p>
                            </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Item Code :</label>
                <input type="text" name="scode" value={itemCode} readOnly/>
              </div>
              <div className="form-group">
                <label>Item Name :</label>
                <input type="text" name="sname" value={subDetails.itemName} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>UOM :</label>
                <input type="text" name="uom" value={subDetails.uom} readOnly/>
              </div>
              <div className="form-group">
                <label>Price :</label>
                <input type="text" name="price" value={formData.price} onChange={handleInputChange} />
              </div>
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label>GST% :</label>
                <input type="number" name="gst" value={formData.gst} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>P&F % :</label>
                <input type="number" name="pf" value={formData.pf} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Disc % :</label>
                <input type="number" name="disc" value={formData.disc} onChange={handleInputChange}/>
              </div>

<div className="form-group">
  <label>Quality :</label>
  <select name = "quality" 
    value={formData.quality ? ratingLabels.indexOf(formData.quality) : ""}
    onChange={handleInputChange}
  >
    <option value="1">Average</option>
    <option value="3">Excellent</option>
    <option value="2">Good</option>
    <option value="0">Poor</option>
  </select>
</div>


            </div>

            <div className="form-row">
              <div className="form-group">
                <label>After Sales Support :</label>
                <select name = "afterSalesSupport" 
    value={formData.afterSalesSupport ? ratingLabels.indexOf(formData.afterSalesSupport) : ""}
    onChange={handleInputChange}
  >
                    <option value="1">Average</option>
                    <option value="3">Excellent</option>
                    <option value="2">Good</option>
                    <option value="0">Poor</option>
                </select>
              </div>
              <div className="form-group">
                <label>Delivery :</label>
                <select name="delivery"
    value={formData.delivery ? ratingLabels.indexOf(formData.delivery) : ""}
    onChange={handleInputChange}
  >
                    <option value="1">Average</option>
                    <option value="3">Excellent</option>
                    <option value="2">Good</option>
                    <option value="0">Poor</option>
                </select>
              </div>
            </div>



            <div className="btn-cls">
              <button type="submit" className="submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModifySupplierWithItem;
